import { render, staticRenderFns } from "./comp_CartItem.vue?vue&type=template&id=5fea41a0&scoped=true&"
import script from "./comp_CartItem.vue?vue&type=script&lang=js&"
export * from "./comp_CartItem.vue?vue&type=script&lang=js&"
import style0 from "./comp_CartItem.vue?vue&type=style&index=0&id=5fea41a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea41a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
